module.exports = __webpack_public_path__ + "static/media/DSC03811.aeedcfa4.jpg";